/**
 * BuyerJourneyErrors (AJIP-16.02.007 · WS16)
 */
import { JourneyError } from '../core/JourneyErrors';

class BuyerJourneyError extends JourneyError {}
class InvalidBuyerContextError extends BuyerJourneyError {}
class InvalidBuyerStageError extends BuyerJourneyError {}
class InvalidBuyerTransitionError extends BuyerJourneyError {}
class BuyerJourneyNotActiveError extends BuyerJourneyError {}
class BuyerJourneyReentryError extends BuyerJourneyError {}
class RFQBoundaryError extends BuyerJourneyError {}
class TrustMatchBoundaryError extends BuyerJourneyError {}

const BUYER_JOURNEY_ERROR_TYPES = Object.freeze([
  'BuyerJourneyError', 'InvalidBuyerContextError', 'InvalidBuyerStageError',
  'InvalidBuyerTransitionError', 'BuyerJourneyNotActiveError',
  'BuyerJourneyReentryError', 'RFQBoundaryError', 'TrustMatchBoundaryError',
]);

export {
  BuyerJourneyError, InvalidBuyerContextError, InvalidBuyerStageError,
  InvalidBuyerTransitionError, BuyerJourneyNotActiveError,
  BuyerJourneyReentryError, RFQBoundaryError, TrustMatchBoundaryError,
  BUYER_JOURNEY_ERROR_TYPES,
};
